const LOCAL_STORAGE_KEYS = Object.freeze({
  DASHBOARD_PASS_STATUS: "dashboardPassesStatus",
  DASHBOARD_PASS_TYPE: "dashboardPassesType",
  LOCALE_TYPE: "applicationLocaleType"
})

const DEFAULT_LOCALE_LANGUAGE = "en"

const PASS_APP_LOCALE_OPTIONS = Object.freeze({
  options: [
    { label: "English", value: "en" },
    { label: "Spanish", value: "es" }
  ]
})

const PASS_TYPE_NAMES = Object.freeze({
  TOTAL: "total",
  ACTIVE: "active",
  MY: "my",
  MY_ACTIVE: "myActive",
  FLAGGED: "flagged",
  WAITING_FOR_APPROVAL: "waitingForApproval"
})

const APPOINTMENT_METRICS_KEY = Object.freeze({
  TODAY: "today",
  AWAITING_TODAY: "awaitingToday",
  FUTURE: "future"
})

const APPOINTMENT_METRICS_OPERATIONS = Object.freeze({
  INCREMENT: "increment",
  DECREMENT: "decrement"
})

const DEFAULT_FILE_UPLOAD_MODE_FOR_TARDY = "manual"

// Feature Flag: School IDs for which toast notifications should be disabled
// Add comma-separated school IDs to disable toasts for specific schools
const TOAST_DISABLED_SCHOOL_IDS = "5252"

export default {
  LOCAL_STORAGE_KEYS,
  PASS_TYPE_NAMES,
  APPOINTMENT_METRICS_KEY,
  APPOINTMENT_METRICS_OPERATIONS,
  DEFAULT_LOCALE_LANGUAGE,
  PASS_APP_LOCALE_OPTIONS,
  DEFAULT_FILE_UPLOAD_MODE_FOR_TARDY,
  TOAST_DISABLED_SCHOOL_IDS
}
